import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    num: '01',
    title: 'Chart Engineering',
    desc: 'Before the session, Acharyaji personally analyzes your Lagna chart, Navamsha, Dashamsha, and current Dasha-Antardasha sequence. No automated software reports. Every reading is handcrafted.',
  },
  {
    num: '02',
    title: 'The Clarity Session',
    desc: 'A focused dialogue. We move past generic Rashi analysis and go directly to your current planetary period, its implications for business and Vastu, and the specific Muhurta windows ahead.',
  },
  {
    num: '03',
    title: 'You Leave With Clarity',
    desc: 'By the end of the session, the fog lifts. You understand which cycle you are in, what it means for your decision, and how to move forward with confidence. No dependency created. Just clarity you can act on.',
  },
];

export default function Process() {
  return (
    <section className="py-24 px-6 md:px-12 bg-brand-dark text-brand-light relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-gold/10 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="max-w-5xl mx-auto relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-center mb-24"
        >
          <p className="text-brand-gold text-sm uppercase tracking-[0.3em] font-bold mb-4">
            The Methodology
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-6 leading-tight">
            Precision Over <br />
            <span className="italic text-brand-gold">Prediction</span>
          </h2>
          <p className="text-stone-300 font-medium text-xl max-w-2xl mx-auto leading-relaxed">
            We do not engage in vague fortune-telling. The process is a structured analysis of your cosmic blueprint, designed to deliver strategic clarity.
          </p>
        </motion.div>

        <div className="space-y-16 relative before:absolute before:inset-0 before:ml-8 md:before:mx-auto md:before:translate-x-0 before:h-full before:w-1 before:bg-gradient-to-b before:from-brand-gold before:via-brand-gold/30 before:to-transparent">
          {steps.map((step, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ delay: i * 0.2, duration: 0.7 }}
              className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group"
            >
              <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-brand-dark bg-brand-gold text-brand-dark font-serif text-2xl font-bold z-10 shrink-0 md:mx-auto absolute left-0 md:left-1/2 md:-translate-x-1/2 shadow-[0_0_20px_rgba(212,175,55,0.4)]">
                {step.num}
              </div>
              
              <div className="pl-24 md:pl-0 w-full md:w-[calc(50%-4rem)] p-10 rounded-sm bg-white/5 border border-brand-gold/20 backdrop-blur-md hover:bg-white/10 hover:border-brand-gold/50 transition-all duration-500 shadow-xl">
                <h3 className="font-serif text-3xl text-brand-gold mb-4">{step.title}</h3>
                <p className="text-stone-200 font-medium text-lg leading-relaxed">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}